//lottie
import '@lottiefiles/lottie-player'

//Styles
import '../style/index.scss'

//Scene
import Experience from './scene/Experience'
const experience = new Experience(document.querySelector('canvas.webgl'))

/**
 * Sections
 */
//intro
import './sections/header'
import './sections/footer'

//Components
import './components/loader'
import './components/Menu'
